import type { AiCostSummary, AiUserCostDetail, AiUsageMetrics } from '../types/adminUser';

export function formatAiCost(value?: number | null, currency = '$'): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  if (value === 0) return `${currency}0.0000`;
  if (Math.abs(value) < 0.000001) return `${currency}${value.toExponential(2)}`;
  return `${currency}${value.toFixed(Math.abs(value) < 0.0001 ? 6 : Math.abs(value) < 1 ? 4 : 2)}`;
}

function numeric(value: unknown): boolean {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}

function metrics(value: AiUsageMetrics): boolean {
  return !!value && ['input_tokens', 'cached_input_tokens', 'output_tokens', 'reasoning_tokens',
    'model_calls', 'cost_usd', 'fx_missing_events', 'legacy_events'].every(key => numeric(value[key as keyof AiUsageMetrics]))
    && (value.cost_eur === null || numeric(value.cost_eur));
}

export function validateAiCostSummary(value: AiCostSummary): AiCostSummary {
  if (!value || !['registered_current_month_cost_usd', 'anonymous_current_month_cost_usd',
    'system_current_month_cost_usd', 'total_current_month_cost_usd', 'registered_users_with_cost_count',
    'avg_cost_per_active_user_usd', 'total_all_time_cost_usd'].every(key => numeric(value[key as keyof AiCostSummary]))
    || ![value.registered, value.anonymous, value.system, value.total_current_month, value.total_all_time].every(metrics)
    || !value.breakdown_by_feature || !Object.values(value.breakdown_by_feature).every(metrics)
    || !value.accounting_health || typeof value.accounting_health.accounting_errors_detected !== 'boolean') {
    throw new Error('Date indisponibile: contract contabilitate AI invalid.');
  }
  return value;
}

export function validateAiUserCost(value: AiUserCostDetail): AiUserCostDetail {
  if (!value || typeof value.user_id !== 'string' || !metrics(value.current_month) || !metrics(value.all_time)
    || !value.breakdown_by_feature || !Object.values(value.breakdown_by_feature).every(metrics)
    || !Array.isArray(value.recent_events)) throw new Error('Date indisponibile: contract consum AI invalid.');
  return value;
}
